// Mock data for Edmonton Services Website

export const companyInfo = {
  name: "K&A Multi-Services",
  tagline: "Junk Removal & Snow Clearing Experts",
  phone: "(780) 555-0123",
  email: "k.atechsolutions12@gmail.com",
  address: "",
  hours: "Mon-Sat: 7AM - 8PM"
};

export const services = [
  {
    id: 1,
    category: "junk",
    title: "Residential Cleanouts",
    description: "Complete basement, garage, and attic clearing. We handle everything from old furniture to accumulated clutter.",
    icon: "Home",
    features: ["Basement clearing", "Garage cleanouts", "Attic removal", "Estate cleanups"]
  },
  {
    id: 2,
    category: "junk",
    title: "Commercial Services",
    description: "Office furniture removal, construction debris cleanup, and retail space clearing for businesses of all sizes.",
    icon: "Building2",
    features: ["Office furniture", "Construction debris", "Retail cleanouts", "Warehouse clearing"]
  },
  {
    id: 3,
    category: "junk",
    title: "Specialized Hauling",
    description: "Appliance disposal, mattress removal, yard waste, and eco-friendly recycling of electronics.",
    icon: "Truck",
    features: ["Appliance disposal", "Mattress removal", "Yard waste", "E-waste recycling"]
  },
  {
    id: 4,
    category: "snow",
    title: "Residential Snow Removal",
    description: "Keep your driveway, walkways, and entrances clear and safe all winter long with our reliable service.",
    icon: "Snowflake",
    features: ["Driveway clearing", "Walkway shoveling", "Entrance de-icing"]
  },
  {
    id: 5,
    category: "snow",
    title: "Commercial Snow Clearing",
    description: "24/7 commercial snow removal for parking lots, storefronts, and business properties.",
    icon: "Building",
    features: ["Parking lots", "Storefronts", "Loading docks", "Emergency service"]
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Schedule",
    description: "Book online or call us. Choose a time that works for you – same-day service often available.",
    icon: "Calendar"
  },
  {
    step: 2,
    title: "On-Site Quote",
    description: "We arrive and provide a firm, no-obligation price. No hidden fees, no surprises.",
    icon: "ClipboardCheck"
  },
  {
    step: 3,
    title: "Point & It's Gone",
    description: "Just show us what needs to go. We handle all the heavy lifting and cleanup.",
    icon: "Sparkles"
  }
];

export const serviceAreas = [
  "Downtown Edmonton",
  "West Edmonton",
  "South Edmonton",
  "North Edmonton",
  "Sherwood Park",
  "St. Albert",
  "Spruce Grove",
  "Fort Saskatchewan"
];

export const stats = [
  { value: "5000+", label: "Jobs Completed" },
  { value: "98%", label: "Customer Satisfaction" },
  { value: "24/7", label: "Emergency Service" },
  { value: "15+", label: "Years Experience" }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "West Edmonton",
    text: "They cleared out my entire garage in under 2 hours. Professional, fast, and fair pricing!",
    rating: 5,
    service: "Junk Removal"
  },
  {
    id: 2,
    name: "Mike T.",
    location: "St. Albert",
    text: "Best snow removal service in the area. They're always on time, even during heavy snowfalls.",
    rating: 5,
    service: "Snow Removal"
  },
  {
    id: 3,
    name: "Jennifer L.",
    location: "Sherwood Park",
    text: "Used them for an estate cleanout. Compassionate, efficient, and they donated usable items.",
    rating: 5,
    service: "Junk Removal"
  }
];

export const commitments = [
  {
    title: "On-Time Guarantee",
    description: "We arrive when we say we will, or you get 10% off your service.",
    icon: "Clock"
  },
  {
    title: "Eco-Friendly Disposal",
    description: "We donate, recycle, and responsibly dispose of items whenever possible.",
    icon: "Leaf"
  },
  {
    title: "Transparent Pricing",
    description: "No hidden fees. The quote we give is the price you pay.",
    icon: "BadgeDollarSign"
  }
];
